export const settings = [
  {
    label: "Background",
    selector: "background",
    type: "background-image",
    value:
      "url(https://embed.filekitcdn.com/e/2owDSJCEZcjwZhVLK4rMrK/2vJTtpQyc87b2ZVG9bQ3aA)"
  },
  {
    label: "Background Color",
    selector: "form",
    type: "background-color",
    value: "#2E2E2E"
  },
  {
    label: "Border radius",
    selector: "form",
    type: "border-radius",
    value: 0
  },
  {
    group: "header",
    selector: "header",
    type: "color",
    value: "#ffffff"
  },
  {
    group: "header",
    selector: "header",
    type: "font-weight",
    value: 700
  },
  {
    group: "content",
    selector: "content",
    type: "color",
    value: "#ffffff"
  },
  {
    group: "field",
    selector: "field",
    type: "color",
    value: "#6e6e6e"
  },
  {
    group: "field",
    selector: "field",
    type: "font-weight",
    value: 400
  },
  {
    group: "field",
    selector: "field",
    type: "background-color",
    value: "#1B1B1B"
  },
  {
    group: "field",
    selector: "field",
    type: "border-radius",
    value: 4
  },
  {
    group: "button",
    selector: "button",
    type: "color",
    value: "#ffffff"
  },
  {
    group: "button",
    selector: "button",
    type: "background-color",
    value: "#f57148"
  },
  {
    group: "button",
    selector: "button",
    type: "border-radius",
    value: 4
  },
  {
    group: "button",
    selector: "button",
    type: "font-weight",
    value: 700
  },
  {
    group: "disclaimer",
    selector: "disclaimer",
    type: "color",
    value: "#CBCBCB"
  }
]
